import React, { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { Check } from "lucide-react";
import { PremiumGlowButton } from "./PremiumGlowButton";
import { faqs } from "../data/faqs";
const trustIndicators = ["Pago 100% seguro", "Acceso inmediato", "Garantía de 7 días"];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const shouldReduceMotion = Boolean(useReducedMotion());
  return <section aria-labelledby="faq-heading" className="relative isolate w-full overflow-hidden bg-[#090B0D] py-20 text-[#F8F8F6] sm:py-24 lg:py-28" data-id="element-56" data-mp="28bb3eur6gk4v">
      <div aria-hidden="true" className="pointer-events-none absolute bottom-0 left-1/2 -z-10 h-[520px] w-[90%] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,rgba(242,184,75,0.055),transparent_70%)]" data-id="element-57" data-mp="1uhacuoadq3fl" />

      <div className="mx-auto max-w-[1040px] px-4 sm:px-8 lg:px-12" data-id="element-58" data-mp="2rzagwdd4m5dz">
        <header className="text-center" data-id="element-59" data-mp="2s0lkod6knd53">
          <div className="flex items-center justify-center gap-3" data-id="element-60" data-mp="14uim33lq9tk0">
            <span aria-hidden="true" className="h-px w-8 bg-[#F2B84B]/55" data-id="element-61" data-mp="10tp40quyv8z1" />
            <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#F2B84B] sm:text-xs" data-id="element-62" data-mp="10rm2paod5tf0">
              Dudas frecuentes
            </p>
            <span aria-hidden="true" className="h-px w-8 bg-[#F2B84B]/55" data-id="element-63" data-mp="19tc499bym8qi" />
          </div>
          <h2 id="faq-heading" className="mt-4 text-[2rem] font-bold leading-tight tracking-[-0.035em] text-[#F8F8F6] sm:text-[2.5rem] lg:text-[3.25rem]" data-id="element-64" data-mp="1oii1wsv5fqwa">
            Preguntas Frecuentes
          </h2>
        </header>

        <div className="mx-auto mt-10 max-w-[900px] border-t border-[#30343A] sm:mt-12" data-id="element-65" data-mp="1xhv9ffzpq5ed">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const answerId = `faq-answer-${index}`;
          const buttonId = `faq-question-${index}`;
          return <div key={faq.question} className="border-b border-[#30343A]" data-id="element-66" data-mp="3uem2y1vlmkqc" data-mpi={index}>
                <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={answerId} onClick={() => setOpenIndex(isOpen ? null : index)} className="group flex min-h-16 w-full items-center justify-between gap-5 py-5 text-left text-base font-semibold leading-6 text-[#F8F8F6] transition-colors duration-200 hover:text-[#F2B84B] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#F2B84B]/60 sm:min-h-[76px] sm:py-6 sm:text-lg" data-id="element-67" data-mp="1yaxsf273ra0p">
                  <span data-id="element-68" data-mp="2qzv950vo0yrc">{faq.question}</span>
                  <span className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[#F2B84B]/35 bg-[#F2B84B]/[0.06] text-[#F2B84B] transition-[border-color,background-color] duration-300 group-hover:border-[#F2B84B]/60 group-hover:bg-[#F2B84B]/10" data-id="element-69" data-mp="2vx4w89vl0yc0">
                    <span className="absolute h-px w-3.5 bg-current" data-id="element-70" data-mp="tapsrw4929yo" />
                    <span className={`absolute h-3.5 w-px bg-current transition-transform ${shouldReduceMotion ? "duration-0" : "duration-300"} ${isOpen ? "rotate-90" : "rotate-0"}`} data-id="element-71" data-mp="t7tw0b451rbt" />
                  </span>
                </button>

                <AnimatePresence initial={false} data-id="element-72" data-mp="1c0fvr6i6221o">
                  {isOpen && <motion.div id={answerId} role="region" aria-labelledby={buttonId} initial={shouldReduceMotion ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={shouldReduceMotion ? {
                display: "none"
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: shouldReduceMotion ? 0 : 0.3,
                ease: [0.22, 1, 0.36, 1]
              }} className="overflow-hidden" data-id="element-73" data-mp="17z2rh0uq26wv">
                      <p className="max-w-[800px] pb-6 pr-12 text-[15px] leading-[1.65] text-[#B7BBC0] sm:pb-7 sm:text-base" data-id="element-74" data-mp="11j2n2t5s67es">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mx-auto mt-14 flex max-w-[900px] flex-col items-center sm:mt-16" data-id="element-75" data-mp="1ya4jemnyis92">
          <div className="flex w-full max-w-[370px] justify-center" data-id="element-76" data-mp="1kgdc7kxp7kgi">
            <PremiumGlowButton checkout label="Quiero comprar ahora →" data-id="element-77" data-mp="1peon7yzqc10b" />
          </div>

          <ul aria-label="Beneficios de la compra" className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs text-[#B7BBC0] sm:text-sm" data-id="element-78" data-mp="2d3zm1axirlbt">
            {trustIndicators.map(indicator => <li key={indicator} className="flex items-center gap-1.5" data-id="element-79" data-mp="2n9r4i0spk455">
                <Check aria-hidden="true" className="h-3.5 w-3.5 stroke-[2.6] text-[#F2B84B]" data-id="element-80" data-mp="310mifri2dbfl" />
                <span data-id="element-81" data-mp="2w1jds85zx785">{indicator}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}